import { useQuery } from "@tanstack/react-query";
import { DateTime } from "luxon";

import useApiHelper from "../hooks/useApiHelper";
import {
  IVehicleAcquisitionDrilldownResponse,
  VehicleAcquisitionMetricKey,
} from "../models/VehicleAcquisitionDrilldown";

export default function useVehicleAcquisitionDrilldown(
  metric: VehicleAcquisitionMetricKey | null
) {
  const { get } = useApiHelper();
  const today = DateTime.now().toISODate() ?? "";

  return useQuery({
    queryKey: ["vehicleAcquisitionDrilldown", metric, today],
    queryFn: () =>
      get<IVehicleAcquisitionDrilldownResponse>(
        `/stats/vehicle-acquisition/${metric}?from=${encodeURIComponent(
          today
        )}&to=${encodeURIComponent(today)}`
      ),
    staleTime: 1000 * 60,
    enabled: !!metric,
  });
}
